export default __webpack_public_path__ + "static/media/ricardonora.5044d0ce.jpg";